import React, { useState, useCallback, useEffect } from "react";
import moment from 'moment'
import { Calendar, momentLocalizer } from 'react-big-calendar'
import "react-big-calendar/lib/css/react-big-calendar.css";
import Sidennav from '../dashboard/sidenavbar';
import Topnavbar from '../dashboard/topnavbar';
import { Modal, Button } from "react-bootstrap";
import Moment from "moment";
import { baseurladdress } from '../baseurl';
import axios from 'axios';
import * as $ from 'jquery';





export default function HolidayCalender() {




    const Swal = require('sweetalert2')
    const accesstoken = localStorage.getItem("token");
    const accessuserid = localStorage.getItem("id");
    const date = new Date();
    const defaultValue = date.toLocaleDateString("en-CA");
    moment.locale("en-GB");
    const localizer = momentLocalizer(moment);
    const myEventsList = [
        {
            start: new Date(),
            end: new Date(),
            title: "Today",
            allday: false,
        },
    ];








    const [branch_names, setbranch_names] = useState([]);

    const [holidayname, setholidayname] = useState("");
    const [holidaydescription, setholidaydescription] = useState("");
    const [holidaydate, setholidaydate] = useState("");
    const [branchname, setbranchname] = useState("");
    const [holidaybranch, setholidaybranch] = useState("");
    const [showshift, setshowshift] = useState(false);
    const [addshift, setaddshift] = useState(false);
    const [showModal, setShow] = useState(false);
    const [dataa, setDataa] = useState(false);
    //FOR CALENDER

    const [data, setData] = useState(myEventsList);

    //LISTING THE EVENTS IN THE CALENDER

    useEffect(() => {
        const getholidays = () => {
            axios.get(baseurladdress + `getallholidays`, {
                headers: { Authorization: `Bearer ${accesstoken}` },
            })
                .then(res => {
                    const data = res.data.response;
                    console.log(data);
                    let appointments = data;
                    //alert(appointments)
                    for (let i = 0; i < appointments.length; i++) {
                        const getdate = new Date(appointments[i].ddchrholiday_date);
                        const setdatestart = new Date();

                        //for getting the Appointment start date and time
                        setdatestart.setFullYear(getdate.getFullYear());
                        setdatestart.setMonth(getdate.getMonth());
                        setdatestart.setDate(getdate.getDate());


                        //for getting the Appointment end data and time
                        const setdateend = new Date();
                        setdateend.setFullYear(getdate.getFullYear());
                        setdateend.setMonth(getdate.getMonth());
                        setdateend.setDate(getdate.getDate());



                        appointments[i].start = moment.utc(setdatestart).toDate();
                        appointments[i].end = moment.utc(setdateend).toDate();
                        appointments[i].title = appointments[i].ddchrholiday_name;

                        appointments[i].allday = false;
                    }
                    setData(appointments);
                    console.log("data", appointments);

                }).catch(error => {
                    alert(error);
                })
        }
        getholidays()
    }, [])

    //NULL THE SELECTED BRANCHES

    const branchnull = () => {
        setbranchname("");
    }

    // GET ALL BRANCHES 👇

    useEffect(() => {
        const getBranchs = () => {
            axios.get(baseurladdress + `getallbranchs`, {
                headers: { Authorization: `Bearer ${accesstoken}` },
            })
                .then(res => {
                    const data = res.data.response;
                    console.log(data);
                    const user = data.map((item, index) => {
                        return (
                            <option value={item.branch_id}> {item.branch_name} </option>
                        )
                    }
                    );
                    setbranch_names(user);
                }).catch(error => {
                    alert(error);
                })
        }
        getBranchs()
    }, [])

    useEffect(() => {
        const GetAllBranches = () => {

            axios
                .get(baseurladdress + `getallshift`, {
                    headers: { Authorization: `Bearer ${accesstoken}` },
                })
                .then(res => {
                    const datas = res.data.response;
                    console.log("itemss" + datas);
                    const user = datas.map((item, index) => (

                        <tr style={{ textAlign: "center" }} id={"chk" + item.user_id} >

                            <td>{item.ddchrleave_shiftname}</td>
                            <td>{item.ddchrleave_description}</td>
                            <td>
                                {(item.ddchrleave_timefrom === "00:00:00"
                                    ? ""
                                    : item.ddcshifts_timefrom) +
                                    " - " +
                                    (item.ddcshifts_timeto === "00:00:00"
                                        ? ""
                                        : item.ddcshifts_timeto)}
                            </td>



                            <td style={{ "textAlign": "center" }}>
                                <a class="inline-block tbnss"

                                >
                                    <i class="text-primary fa fa-edit"></i>
                                </a>
                            </td>

                        </tr>
                    ));

                    setDataa(user);
                })
                .catch(error => {
                    alert(error);
                })
        }
        GetAllBranches();
    }, []);

    useEffect(() => {
        const getholidays = () => {
            axios.get(baseurladdress + `getallholidays`, {
                headers: { Authorization: `Bearer ${accesstoken}` },
            })
                .then(res => {
                    const data = res.data.response;
                    console.log(data);
                    for (let i = 0; i < data.length; i++) {
                        console.log(data[i])
                    }
                    //  setFromdate(new Date(data.ddchrholiday_date));
                    // setevent(data.ddchrholiday_name);
                }).catch(error => {
                    alert(error);
                })
        }
        getholidays()
    }, [])

    const shiftlist = () => {
        setshowshift(true)
    }

    //STATE FOR GETTING NAME IN DROPBOX

    const change = (event) => {
        var index = event.nativeEvent.target.selectedIndex;
        var coun = event.nativeEvent.target[index].text;
        setbranchname(coun)
    }
    //DISABLE THE DROPDOWN WHILE CLICKING ON CHECHK BOX 👇

    $(function () {
        $('#idcheckbox').change(function () {
            if ($(this).is(':checked')) {
                // disable the dropdown:
                $('#iddropdown').attr('disabled', 'disabled');
            } else {
                $('#iddropdown').removeAttr('disabled');
            }
        });
    });




    //ALERT OF THE EVENT 👇

    const handleSelectEvent = useCallback(
        (event) => window.alert(event.title),
        []
    )

    //SUBMIT EVENT 👇

    const handleSubmit = (event) => {
        event.preventDefault();
        const data = {

            ddchrholiday_name: holidayname,
            ddchrholiday_description: holidaydescription,
            ddchrholiday_date: holidaydate,
            ddchrholiday_branchid: holidaybranch,
            ddchrholiday_branchname: branchname,
            ddchrholiday_crtby: accessuserid
        };
        fetch(
            baseurladdress + `AddHoliday`,
            {
                method: "POST",

                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${accesstoken}`,
                },
            }
        )
            .then((res) => res.json())
            .then((result) => {
                if (result["status"] === "success") {
                    //alert("Branch added successfully");
                    //alert("Branch added successfully");
                    // window.location.href = "/branchlist";
                    const Toast = Swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 1800,
                        timerProgressBar: true,
                        didOpen: (toast) => {
                            toast.addEventListener('mouseenter', Swal.stopTimer)
                            toast.addEventListener('mouseleave', Swal.resumeTimer)
                        }
                    })

                    Toast.fire({
                        icon: 'success',
                        title: 'Holiday added successfully'
                    })


                }
                else {
                    const Toast = Swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 1800,
                        timerProgressBar: true,
                        didOpen: (toast) => {
                            toast.addEventListener('mouseenter', Swal.stopTimer)
                            toast.addEventListener('mouseleave', Swal.resumeTimer)
                        }
                    })

                    Toast.fire({
                        icon: 'error',
                        title: 'Error'
                    })

                }
                window.location.reload();
            });



    };

    return (
        <>
            <Sidennav />
            <Topnavbar />
            <div className="content-wrap">
                <div className="main">
                    <div className="container-fluid">

                        {/* /# row */}
                        <section id="main-content">

                            <div class="card">
                                <div class="card-body">

                                    <div class="default-tab">
                                        <ul class="nav nav-tabs" role="tablist">
                                            <li class="nav-item">
                                                <a class="nav-link active" data-toggle="tab" href="#Calender"
                                                >Calender</a>
                                            </li>
                                            <li class="nav-item">
                                                <a class="nav-link" data-toggle="tab" href="#Attendence"
                                                >Staff Attendence</a>
                                            </li>

                                        </ul>
                                        <div class="tab-content">
                                            <div class="tab-pane fade show active" id="Calender" role="tabpanel">
                                                <div class="col-sm-12 float-lg-right text-right">

                                                    <button
                                                        type="button"
                                                        class="d-grid gap-2 d-md-flex justify-content-md-end"
                                                        className="btn btn-primary"
                                                        onClick={shiftlist}
                                                    >
                                                        SHIFT
                                                    </button>

                                                </div>

                                                <div className="row">

                                                    <div className="col-lg-9">
                                                        <div className="card">

                                                            <Calendar
                                                                localizer={localizer}
                                                                events={data}
                                                                startAccessor="start"
                                                                endAccessor="end"
                                                                eventPropGetter={(event) => {
                                                                    const backgroundColor = event.allday
                                                                        ? "#28a745"
                                                                        : "#3174ad";
                                                                    return { style: { backgroundColor } };
                                                                }}

                                                                style={{ height: 600 }}
                                                                onSelectEvent={handleSelectEvent}

                                                            />

                                                        </div>
                                                    </div>
                                                    <div className="col-lg-3">
                                                        <form>
                                                            <div className="card">
                                                                <div className=" col-lg-12">
                                                                    <h6> HOLIDAY </h6>
                                                                    <input type="text" required class="form-control" id="eventname" onChange={(e) => setholidayname(e.target.value)} />
                                                                </div>

                                                                <div class="form-group col-md-12">
                                                                    <h6>Description </h6>
                                                                    <textarea class="form-control text textaddstaff" onChange={(e) => setholidaydescription(e.target.value)} />

                                                                </div>
                                                                <div className="col-lg-12">
                                                                    <h6>Date </h6>
                                                                    <input
                                                                        type="date"
                                                                        id="fromdate"
                                                                        className="form-control"
                                                                        defaultValue={defaultValue}
                                                                        onChange={(e) => setholidaydate(e.target.value)}
                                                                        required
                                                                    />
                                                                </div>
                                                                {/* <div className="col-lg-12">
                                                                <h6>To </h6>
                                                                <input
                                                                    type="date"
                                                                    id="todate"
                                                                    className="form-control"
                                                                    defaultValue={defaultValue}

                                                                    required
                                                                />
                                                            </div> */}
                                                                <div className="row">
                                                                    <div className="col-lg-2">
                                                                        <h6>All? </h6>
                                                                        <input type="checkbox" id="idcheckbox" name="nabl" className="selectsingle checku"
                                                                            style={{ cursor: "pointer" }}
                                                                            onClick={branchnull}
                                                                        />


                                                                    </div>
                                                                    <div className="col-lg-10">
                                                                        <h6>Branch</h6>
                                                                        <select
                                                                            className="form-control select"
                                                                            name="Branch"
                                                                            id="iddropdown"
                                                                            placeholder="Enter Role"
                                                                            onChange={(e) => { setholidaybranch(e.target.value); change(e) }}
                                                                        >

                                                                            <option value="" disabled selected>
                                                                                select
                                                                            </option>
                                                                            {branch_names}
                                                                        </select>

                                                                    </div>
                                                                </div>
                                                                <button onClick={handleSubmit} type="button" class="btn btn-primary mb-2"  > <span class="align-middle"><i class="ti-plus"></i></span>Create</button>

                                                            </div>
                                                        </form>
                                                    </div>

                                                </div>
                                            </div>

                                        </div>
                                    </div>

                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>

            <Modal show={showshift}>


                <Modal.Header>
                    <h6>SHIFT LISTING</h6>
                </Modal.Header>
                <Modal.Body>
                    <div class="table-responsive">
                        <table
                            id="customFields"
                            border="2"
                            className="table table-bordered table-hover dataTable dtr-inline  "
                            style={{ width: "100%", textAlign: "center" }}
                        >
                            <thead>
                                <tr>
                                    {/* <th><input type="checkbox" /></th> */}
                                    <th>ShiftName</th><th>ShiftDescription</th><th>Shift Time</th><th>Edit</th><th>Delete</th>
                                </tr>
                            </thead>
                            <tbody>
                                {dataa}


                            </tbody>

                        </table>
                    </div>





                </Modal.Body>

            </Modal>


        </>

    )
}
